export const companyActionTypes = {
  SET_COMPANY: 'SET_COMPANY',
  SET_COMPANY_VALIDATED: 'SET_COMPANY_VALIDATED'
};